// @ts-ignore

import { css } from '@compiled/react';

import { Button, ButtonColor, ButtonType } from '@/components/wpl/button/src/button';

export interface TryPageCardProps {
	logo?: JSX.Element;
	title?: string;
	link: string;
	bodyText: string;
	ctaText: string;
	buttonColor?: ButtonColor;
	buttonType?: ButtonType;
}

const pStyle = css({
	fontSize: '1rem',
	marginBlockStart: '0 !important',
	marginBlockEnd: '24px',
});

const tryPageCardStyles = css({
	padding: '16px 0',
});

const logoBlockStyles = css({
	marginBlockEnd: '10px', // reduce by 6px to account for auto-padding of 6px added to bottom of svg
	padding: '0',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	svg: {
		height: '32px',
		width: 'auto',
		maxWidth: '100%',
	},
});

const StyledLogo = (logo: JSX.Element) => {
	return <div css={logoBlockStyles}>{logo}</div>;
};

export const TryPageCard = (props: TryPageCardProps) => {
	const { title, logo, link, bodyText, ctaText, buttonColor, buttonType } = props;
	const styledLogo = logo && StyledLogo(logo);

	return (
		<div css={tryPageCardStyles}>
			{title && <h3>{title}</h3>}
			{styledLogo && <a href={link}>{styledLogo}</a>}
			<p className="tryCardText" css={pStyle}>
				{bodyText}
			</p>
			<Button
				className={'ctaButton'}
				text={ctaText}
				type={buttonType ?? 'secondary'}
				url={link}
				size={'small'}
				color={buttonColor ?? 'darkblue'}
				dataEventProps={{
					'data-product-key': 'try',
					'data-event-component': 'linkButton',
					'data-event-container': 'cardSection',
					'data-event': 'clicked',
					'data-label': ctaText,
				}}
			/>
		</div>
	);
};
